import { djangoApi } from "./auth";

const ROOT = "/api/beginner";

// Main exam
export const getBeginnerMainExams = () =>
  djangoApi.get(`${ROOT}/main-exams/`);

export const startBeginnerMainExam = (examAccessId) =>
  djangoApi.post(`${ROOT}/main-exams/${examAccessId}/start/`);

export const getBeginnerAttempt = (attemptId) =>
  djangoApi.get(`${ROOT}/main-exam-attempts/${attemptId}/`);

export const saveBeginnerAnswer = (attemptId, payload) =>
  djangoApi.post(
    `${ROOT}/main-exam-attempts/${attemptId}/answers/`,
    payload
  );

export const submitBeginnerAttempt = (attemptId) =>
  djangoApi.post(
    `${ROOT}/main-exam-attempts/${attemptId}/submit/`
  );

// Student results
export const getMyBeginnerResults = () =>
  djangoApi.get(`${ROOT}/my-results/`);

// Admin results
export const getAdminBeginnerResults = () =>
  djangoApi.get(`${ROOT}/admin/results/`);

export const updateAdminBeginnerResult = (payload) =>
  djangoApi.patch(`${ROOT}/admin/results/`, payload);

// Normalize API response arrays
export function unwrapRows(response) {
  const data = response?.data;

  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data?.data)) return data.data;

  return [];
}